import { render, staticRenderFns } from "./TaskSessionForm.vue?vue&type=template&id=dc5f409a&"
import script from "./TaskSessionForm.vue?vue&type=script&lang=js&"
export * from "./TaskSessionForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskSessionForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports